"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledButtonContainer = exports.StyledButton = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Button = _interopRequireDefault(require("../../Buttons/Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledButton = (0, _styledComponents.default)(_Button.default).withConfig({
  displayName: "BusinessEntityTypeSelectorstyles__StyledButton",
  componentId: "i9l4f-0"
})(["flex:1 1 48%;max-width:48%;:nth-child(odd){margin-right:", ";}:nth-child(even){margin-left:", ";}"], function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return props.theme.standardPadding;
});
exports.StyledButton = StyledButton;

var StyledButtonContainer = _styledComponents.default.div.withConfig({
  displayName: "BusinessEntityTypeSelectorstyles__StyledButtonContainer",
  componentId: "i9l4f-1"
})(["display:flex;flex-flow:row wrap;justify-content:space-between;"]);

exports.StyledButtonContainer = StyledButtonContainer;